import React, { useState } from "react";
import { toast } from "react-toastify";

const ExportReportCSV = ({
  reportType,
  reportKey,
  startDate,
  endDate,
  limit,
  exportReportAsCSV,
}) => {
  const [isExporting, setIsExporting] = useState(false);

  const isDisabled =
    !reportType || reportType === "0" || !reportKey || reportKey === "0";
  const handleExportCSV = async () => {
    try {
      setIsExporting(true);

      await exportReportAsCSV({
        reportType,
        reportKey,
        startDate,
        endDate,
        limit,
      });

      toast.success("CSV exported successfully 🎉");
    } catch (error) {
      toast.error(error?.message || "Failed to export CSV");
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <button
      onClick={handleExportCSV}
      type="button"
      disabled={isDisabled}
      className={`font-medium rounded-[5px] text-sm px-8 py-2.5 text-center w-[322px] 
        ${
          isDisabled
            ? "bg-[#EAEAEA] text-[#898989] cursor-not-allowed"
            : "text-[#005C53] bg-[#F0FFFE] hover:bg-[#F0FFFE] cursor-pointer"
        }`}
    >
      {isExporting ? (
        <div className="w-full flex items-center justify-center gap-2">
          <svg
            className="animate-spin h-4 w-4 text-[#005C53]"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8h4z"
            />
          </svg>
          Exporting...
        </div>
      ) : (
        "Export as CSV"
      )}
    </button>
  );
};

export default ExportReportCSV;
